// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"aedad911","856":"22a8381e","873":"52619fa1","949":"e69173e6"}[chunkId] + ".chunk.css";
};